import React, { useCallback } from 'react';

import Spinner from './spinner.component';

type RefreshEntityNavigationButtonProps = {
  refreshEntity: Function,
  buttonLabel: string,
  isRefreshingEntity: boolean,
};

export const RefreshEntityNavigationButton = ({
  refreshEntity,
  buttonLabel,
  isRefreshingEntity,
}: RefreshEntityNavigationButtonProps) => {
  const onClick = useCallback(() => refreshEntity(), [refreshEntity]);

  return (
    <button
      className="hamburger-action sub-nav-link link-button"
      tabIndex={0}
      onClick={onClick}
      disabled={isRefreshingEntity}
    >
      {isRefreshingEntity
        ? (
          <span><Spinner small/>Refreshing...</span>
        )
        : buttonLabel}
    </button>
  );
};
